import { FC } from 'react'

import { useParams } from 'react-router-dom'

import { ResourceDetailView } from 'core/resources'
import {
  useGetByoTwilio,
  useUpdateByoTwilio,
} from 'core/types/generated/company/hooks'
import { resourceCatalog } from 'core/types/generated/resources'
import {
  _3rdpartyByoTwilioResponseSchema,
  _3rdpartyByoTwilioUpdateRequestSchema,
} from 'core/utils/generated/formSchemas'

import { asRequestBody, record } from './helpers'

const resource = resourceCatalog._3rdpartyByoTwilio

/** A singleton: one per company, so the route carries no id. */
export const ByoTwilioDetail: FC = () => {
  const { companyId } = useParams<{ companyId: string }>()
  const result = useGetByoTwilio({ companyId })
  const update = useUpdateByoTwilio({ companyId })

  return (
    <ResourceDetailView
      {...record(result)}
      onSave={async (body) => {
        await update.mutateAsync(asRequestBody(body))
      }}
      resource={resource}
      schema={_3rdpartyByoTwilioResponseSchema}
      updateSchema={_3rdpartyByoTwilioUpdateRequestSchema}
    />
  )
}
